import InputPassword from 'components/Inputs/InputPassword/InputPassword'
import InputText from 'components/Inputs/InputText/InputText'
import Typography from 'components/Typography/Typography'
import { useIntl } from 'react-intl'
import './FormCustomBenefitPayment.scss'
import hocFormCustomBenefitPayment from './hocFormCustomBenefitPayment'

export const LIST_OF_CUSTOM_PROVIDERS = ['GalleryBeta', 'Benefity']

function FormCustomBenefitPayment({ benefitPayment, selectedPayment, setAccount, setPin }) {
    const intl = useIntl()
    if (!LIST_OF_CUSTOM_PROVIDERS.includes(selectedPayment)) {
        return
    }
    return (
        <div className="form-gallery-beta-payment d-flex  justify-content-end">
            <div className="d-flex flex-wrap align-items-end gap-5 p-3">
                <div>
                    <Typography className={'pb-2 flex-grow-1 textNowrap'} variant={'label'}>
                        {intl.formatMessage({ id: 'forms.customBenefitPayment.introLabel' })}
                    </Typography>
                </div>
                <div className="d-flex gap-4 flex-wrap">
                    <div>
                        <InputText
                            label={intl.formatMessage({ id: 'forms.customBenefitPayment.cardNumberLabel' })}
                            placeholder={intl.formatMessage({ id: 'forms.customBenefitPayment.cardNumberPlaceholder' })}
                            onChange={(e) => setAccount(e.target.value)}
                            value={benefitPayment.account}
                        />
                    </div>
                    <div>
                        <InputPassword
                            autoComplete="new-password"
                            label={intl.formatMessage({ id: 'forms.customBenefitPayment.pinLabel' })}
                            placeholder={intl.formatMessage({ id: 'forms.customBenefitPayment.pinPlaceholder' })}
                            onChange={(e) => setPin(e.target.value)}
                            value={benefitPayment.pin}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default hocFormCustomBenefitPayment(FormCustomBenefitPayment)
